<template>
<div>
    <hp5-semantic size-selection="xs">
        <span class="virtualVisits" v-if="clinic.onlineClinic"><hp5-icon name="system-success-base" size="xs" /> Virtual doctor visits</span>
        <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
        <span class="virtualVisits" v-if="clinic.onlineAppointmentAvailable"><hp5-icon name="system-success-base" size="xs" /> Accepting new patients</span>
    </hp5-semantic>
    <hp5-spacing-vertical xs="sm"></hp5-spacing-vertical> 
</div>
</template>

<script setup>

    const props = defineProps({
        clinic: Object
    })

</script>

<style scoped>

    .virtualVisits {
        display: flex;
    }

    hp5-icon {
      margin-right: var(--spacing-xxs);
    }

</style>